import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Avatar, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import EditProfile from './EditProfile';
import HelpDialog from './HelpDialog';
import profileImage from '../../assets/profile.png';
import { useNavigate } from 'react-router-dom';

const ProfileMenu = ({ userId, setActiveComponent, setIsAuthenticated}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [profileOpen, setProfileOpen] = useState(false);
    const [helpOpen, setHelpOpen] = useState(false);
    const navigate = useNavigate();

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleProfileOpen = () => {
        setProfileOpen(true);
        handleMenuClose();
    };

    const handleProfileClose = () => {
        setProfileOpen(false);
    };

    const handleLogout = () => {
        // Clear session storage
        sessionStorage.removeItem('jwt');
        sessionStorage.removeItem('userRole');
        sessionStorage.removeItem('userId');
        handleMenuClose();
        setIsAuthenticated(false);
        navigate('/login');

    };

    const handleHelp = () => {
        setHelpOpen(true); 
        handleMenuClose(); 
    };

    const handleHelpClose = () => {
        setHelpOpen(false); 
    };

    return (
        <>
            <IconButton onClick={handleMenuOpen}>
                <Avatar alt="Profile" src={profileImage} />
            </IconButton>

            {/* Dropdown Menu */}
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={handleProfileOpen}>Edit Profile</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
                <MenuItem onClick={handleHelp}>Help</MenuItem>
            </Menu>

            {/* Edit Profile Dialog */}
            <Dialog open={profileOpen} onClose={handleProfileClose} maxWidth="sm" fullWidth>
                <DialogTitle>Edit Profile</DialogTitle>
                <DialogContent>
                    <EditProfile onClose={handleProfileClose} userId={userId} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleProfileClose}>Close</Button>
                </DialogActions>
            </Dialog>

            <HelpDialog open={helpOpen} onClose={handleHelpClose} />
        </>
    );
};

export default ProfileMenu;
